// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInMixin {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeOutMixin {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.ComparisonSelector-SelectedItems {
  display: flex;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--gray_light2);
  margin: 6px 12px 6px 0;
  cursor: default;
}
.ComparisonSelector-SelectedItems:hover {
  border-color: var(--gray_light1);
}
.ComparisonSelector-SelectedItems.active {
  border-color: var(--color_primary_500);
}
.ComparisonSelector-SelectedItems.clickable {
  cursor: pointer;
}
.ComparisonSelector-SelectedItems .select-group {
  flex-grow: 1;
  padding: 20px;
}
.ComparisonSelector-SelectedItems .selected-content {
  position: relative;
  min-width: 110px;
  display: flex;
  align-items: center;
  padding: 12px;
}
.ComparisonSelector-SelectedItems .selected-content .trend {
  height: 18px;
  width: 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  bottom: -1px;
  border: 1px solid var(--base_color2);
  background-color: var(--trend);
  margin: 0 0 0 8px;
}
.ComparisonSelector-SelectedItems .selected-content .trend .icon {
  height: 10px;
  width: 10px;
  fill: var(--base_color2);
}
.ComparisonSelector-SelectedItems .selected-content .bullet {
  width: 12px;
  height: 12px;
  background-color: var(--gray_light2);
  border-radius: 50%;
  display: block;
  margin-right: 8px;
}
.ComparisonSelector-SelectedItems .selected-content .selected-label {
  display: block;
  position: relative;
  line-height: 1.2;
}
.ComparisonSelector-SelectedItems .selected-content .selected-label .label-container {
  display: flex;
  flex-direction: column;
  color: var(--base_color1);
}
.ComparisonSelector-SelectedItems .selected-content .selected-label .label-container .label {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.ComparisonSelector-SelectedItems .selected-content .selected-label .type {
  top: 100%;
  left: 0;
  color: var(--gray_dark1);
  font-size: 12px;
  margin-top: 2px;
}
.ComparisonSelector-SelectedItems .selected-content .selected-label .type.ellipsis {
  max-width: 240px;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}
.ComparisonSelector-SelectedItems .selected-content .provider {
  height: 20px;
  min-width: 20px;
  width: 20px;
  margin-left: 8px;
}
.ComparisonSelector-SelectedItems .selected-content .close {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 20px;
  height: 20px;
  margin-left: 8px;
}
.ComparisonSelector-SelectedItems .selected-content .close:hover svg {
  fill: var(--primary_dark2);
}`, "",{"version":3,"sources":["webpack://./src/mixins.scss","webpack://./src/components/DashboardModals/CreateDashboardModal/components/TerritorySelector/components/SelectedItems/index.scss"],"names":[],"mappings":"AAwCA;EACE;IACE,UAAA;ECvCF;EDyCA;IACE,UAAA;ECvCF;AACF;AD0CA;EACE;IACE,UAAA;ECxCF;ED0CA;IACE,UAAA;ECxCF;AACF;AAbA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;EACA,eAAA;AAeF;AAbE;EACE,gCAAA;AAeJ;AAZE;EACE,sCAAA;AAcJ;AAXE;EACE,eAAA;AAaJ;AAVE;EACE,YAAA;EACA,aAAA;AAYJ;AATE;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;AAWJ;AATI;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,8BAAA;EACA,iBAAA;AAWN;AATM;EACE,YAAA;EACA,WAAA;EACA,wBAAA;AAWR;AAPI;EACE,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AASN;AANI;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAQN;AANM;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AAQR;AANQ;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAQV;AAJM;EACE,SAAA;EACA,OAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;AAMR;AAJQ;EACE,gBAAA;EDzFR,oBAAA;EACA,aC0F4B;EDzF5B,qBCyF4B;EDxF5B,4BAAA;EACA,gBAAA;EACA,sBANoC;ACsGtC;AALI;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;AAON;AAJI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAMN;AAHQ;EACE,0BAAA;AAKV","sourcesContent":["@mixin line-clamp($lines, $wordBreak: break-word) {\n  display: -webkit-box;\n  line-clamp: $lines;\n  -webkit-line-clamp: $lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: $wordBreak;\n}\n\n@mixin scrollbar(\n  $color: var(--color_neutral_200),\n  $colorHover: var(--color_neutral_400),\n  $colorActive: var(--color_neutral_500)\n) {\n  &::-webkit-scrollbar {\n    width: 7px;\n    height: 7px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: $color;\n    height: 80px;\n    border-radius: 50px;\n  }\n\n  &:hover {\n    &::-webkit-scrollbar-thumb {\n      background: $colorHover;\n    }\n  }\n\n  &::-webkit-scrollbar-thumb:active {\n    background: $colorActive;\n  }\n}\n\n@keyframes fadeInMixin {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOutMixin {\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n@mixin fadeIn($timing, $length, $delay, $fill) {\n  animation: fadeInMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin fadeOut($timing, $length, $delay, $fill) {\n  animation: fadeOutMixin $timing $length $delay;\n  animation-fill-mode: $fill;\n}\n\n@mixin noise {\n  position: relative;\n  &::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    z-index: -1;\n    background-image: url('./assets/images/png/noise.png');\n    background-position: 0% 0%;\n    background-size: 36.23046875px 36.23046875px;\n    background-repeat: repeat;\n    border-radius: 12px;\n    opacity: 0.3;\n  }\n}\n\n@mixin scoped-excluded($selector, $exclude-class) {\n  :is(#{$selector}):not(:where(#{$exclude-class} *)) {\n    @content;\n  }\n}\n","@import 'src/mixins.scss';\n\n.ComparisonSelector-SelectedItems {\n  display: flex;\n  border-radius: 8px;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid var(--gray_light2);\n  margin: 6px 12px 6px 0;\n  cursor: default;\n\n  &:hover {\n    border-color: var(--gray_light1);\n  }\n\n  &.active {\n    border-color: var(--color_primary_500);\n  }\n\n  &.clickable {\n    cursor: pointer;\n  }\n\n  .select-group {\n    flex-grow: 1;\n    padding: 20px;\n  }\n\n  .selected-content {\n    position: relative;\n    min-width: 110px;\n    display: flex;\n    align-items: center;\n    padding: 12px;\n\n    .trend {\n      height: 18px;\n      width: 18px;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      border-radius: 50%;\n      bottom: -1px;\n      border: 1px solid var(--base_color2);\n      background-color: var(--trend);\n      margin: 0 0 0 8px;\n\n      .icon {\n        height: 10px;\n        width: 10px;\n        fill: var(--base_color2);\n      }\n    }\n\n    .bullet {\n      width: 12px;\n      height: 12px;\n      background-color: var(--gray_light2);\n      border-radius: 50%;\n      display: block;\n      margin-right: 8px;\n    }\n\n    .selected-label {\n      display: block;\n      position: relative;\n      line-height: 1.2;\n\n      .label-container {\n        display: flex;\n        flex-direction: column;\n        color: var(--base_color1);\n\n        .label {\n          display: -webkit-box;\n          -webkit-line-clamp: 1;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n        }\n      }\n\n      .type {\n        top: 100%;\n        left: 0;\n        color: var(--gray_dark1);\n        font-size: 12px;\n        margin-top: 2px;\n\n        &.ellipsis {\n          max-width: 240px;\n\n          @include line-clamp(1);\n        }\n      }\n    }\n\n    .provider {\n      height: 20px;\n      min-width: 20px;\n      width: 20px;\n      margin-left: 8px;\n    }\n\n    .close {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      cursor: pointer;\n      width: 20px;\n      height: 20px;\n      margin-left: 8px;\n\n      &:hover {\n        svg {\n          fill: var(--primary_dark2);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
